import React, { Component } from 'react'
import {globals} from '../Globals/Globals'
import axios from 'axios'
import PartnerCard  from '../PartnerCard/PartnerCard'

class PartnersGrid2 extends Component{
    constructor(props){
        super(props)
        this.state={partner_list:null};
    }

    componentDidMount = async (props) => {
        //Let us fetch partners from remote database
        this.fetchPartnersFromButtons(null);
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.categoriesButtonsFilter !== prevProps.categoriesButtonsFilter) {
            this.fetchPartnersFromButtons(this.props.categoriesButtonsFilter);
        }
    }

    fetchPartnersFromButtons = async (partner_buttons_category_filter) =>{
        //Call micro-service
        //Let us fetch partners from remote database
        if (globals.parameters.debugging){
            console.clear();
            console.log("partner_buttons_category_filter ", partner_buttons_category_filter)    
        }
        
        let fetch_partners_url = null;

        if (partner_buttons_category_filter && partner_buttons_category_filter.trim().length > 0)
            fetch_partners_url = `${globals.partners_page_categories_buttons_endpoint.url}?offset=0&size=${this.props.limit?this.props.limit:50}&filter=${partner_buttons_category_filter.trim()}`  
        else
            fetch_partners_url = `${globals.partners_page_categories_buttons_endpoint.url}?offset=0&size=${this.props.limit?this.props.limit:50}`;

        let partners = await axios.get(fetch_partners_url);       
        this.setState({partner_list : partners.data.items});
        console.log("PartnersGrid2 :: fetch_partners_url=>", fetch_partners_url);   
    }

    

    dynamicRender = () => {
        let partners_card_grid = null;

        if (globals.parameters.debugging) 
            console.log("this.state.partner_list =>", this.state.partner_list)
            
        if (!((this.state.partner_list != null) && (this.state.partner_list.length > 0))){
            if(this.props.categoriesButtonsFilter)
                return(<div className='no-result'>{`Aucun Partenaire ne correspond au filtre : catégorie contient ("${this.props.categoriesButtonsFilter}") !!!`}</div>)
            else
                return(<div className='no-result'>{`Chargement des partenaires...`}</div>)
        }
        else{
                partners_card_grid = this.state.partner_list.map(
                    (partnerItem,i)=>{
                    return  <PartnerCard 
                                key={i}
                                data={partnerItem}
                                onClick={() => { console.clear();console.log("PartnersGrid::OnClick => partnerItem", partnerItem);if (this.props.onPartnerClickHandler) this.props.onPartnerClickHandler(partnerItem)}}/>});
            }
        
        return(
            <div className="partners-columns-container">
                {partners_card_grid}
            </div>
            );
    }

    render = () => {
        return(
           this.dynamicRender(this.props.categoriesButtonsFilter) 
        )
    }
} 

export default PartnersGrid2;